import { Home, MapPin, Users, Activity, Footprints, Search, BarChart3, BookOpen } from 'lucide-react';

export const NAVIGATION_CONFIGS = {
    DEVELOPER: {
        switcherActiveColor: 'text-indigo-400',
        switcherIndicatorClass: 'bg-indigo-500 shadow-[0_0_8px_rgba(99,102,241,0.8)]',
        glowClass: 'bg-indigo-500/20',
        hasPlusButton: false,
        leftNavItems: [
            {
                to: '/developer/dashboard',
                label: 'Developer Dashboard',
                icon: Home,
                activeColor: 'text-indigo-400',
                indicatorClass: 'bg-indigo-400 shadow-[0_0_8px_rgba(129,140,248,0.8)]',
                isMatch: (pathname) => pathname === '/developer/dashboard' || pathname === '/developer'
            },
            {
                to: '/developer/docs',
                label: 'API Documentation',
                icon: BookOpen,
                activeColor: 'text-indigo-400',
                indicatorClass: 'bg-indigo-400 shadow-[0_0_8px_rgba(129,140,248,0.8)]',
                isMatch: (pathname) => pathname === '/developer/docs'
            }
        ],
        rightNavItems: []
    },
    HANGOUT: {
        switcherActiveColor: 'text-purple-400',
        switcherIndicatorClass: 'bg-purple-500 shadow-[0_0_8px_rgba(168,85,247,0.8)]',
        glowClass: 'bg-purple-500/20',
        hasPlusButton: true,
        plusButtonGradient: 'from-purple-600 to-pink-600',
        plusButtonAriaLabel: 'Create Hangout',
        leftNavItems: [
            {
                to: '/',
                label: 'Home',
                icon: Home,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/'
            },
            {
                to: '/locations',
                label: 'Locations',
                icon: MapPin,
                activeColor: 'text-purple-400',
                indicatorClass: 'bg-purple-400 shadow-[0_0_8px_rgba(168,85,247,0.8)]',
                isMatch: (pathname) => pathname === '/locations'
            }
        ],
        rightNavItems: [
            {
                to: '/squads',
                label: 'Squads',
                icon: Users,
                activeColor: 'text-emerald-400',
                indicatorClass: 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)]',
                isMatch: (pathname) => pathname === '/squads'
            }
        ]
    },
    BARK: {
        switcherActiveColor: 'text-teal-400',
        switcherIndicatorClass: 'bg-teal-500 shadow-[0_0_8px_rgba(20,184,166,0.8)]',
        glowClass: 'bg-teal-500/20',
        hasPlusButton: true,
        plusButtonGradient: 'from-teal-500 to-cyan-500 shadow-teal-500/20',
        plusButtonAriaLabel: 'Add Pet / Log',
        leftNavItems: [
            {
                to: '/bark',
                label: 'Bark Home',
                icon: Home,
                activeColor: 'text-teal-400',
                indicatorClass: 'bg-teal-400 shadow-[0_0_8px_rgba(20,184,166,0.8)]',
                isMatch: (pathname) => pathname === '/bark'
            },
            {
                to: '/bark/feed',
                label: 'Bark Feed',
                icon: Activity,
                activeColor: 'text-teal-400',
                indicatorClass: 'bg-teal-400 shadow-[0_0_8px_rgba(20,184,166,0.8)]',
                isMatch: (pathname) => pathname === '/bark/feed'
            }
        ],
        rightNavItems: [
            {
                to: '/squads',
                label: 'The Pack',
                icon: Users,
                activeColor: 'text-teal-400',
                indicatorClass: 'bg-teal-400 shadow-[0_0_8px_rgba(20,184,166,0.8)]',
                isMatch: (pathname) => pathname === '/squads' || pathname.startsWith('/squad/')
            },
            {
                to: '/bark/reporting',
                label: 'Pet Health Reporting',
                icon: BarChart3,
                activeColor: 'text-teal-400',
                indicatorClass: 'bg-teal-400 shadow-[0_0_8px_rgba(20,184,166,0.8)]',
                isMatch: (pathname) => pathname === '/bark/reporting'
            }
        ]
    },
    WRENCH: {
        switcherActiveColor: 'text-cyan-400',
        switcherIndicatorClass: 'bg-cyan-500 shadow-[0_0_8px_rgba(6,182,212,0.8)]',
        glowClass: 'bg-cyan-500/20',
        hasPlusButton: true,
        plusButtonGradient: 'from-cyan-500 to-blue-600 shadow-cyan-500/20',
        plusButtonAriaLabel: 'Log Activity',
        leftNavItems: [
            {
                to: '/garage',
                label: 'Garage Home',
                icon: Home,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/garage'
            },
            {
                to: '/garage/search',
                label: 'Global Search',
                icon: Search,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/garage/search'
            },
            {
                to: '/garage/feed',
                label: 'Unified Feed',
                icon: Activity,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/garage/feed'
            }
        ],
        rightNavItems: [
            {
                to: '/squads',
                label: 'Squads',
                icon: Users,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/squads'
            },
            {
                to: '/garage/reporting',
                label: 'Fleet Reporting',
                icon: BarChart3,
                activeColor: 'text-cyan-400',
                indicatorClass: 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]',
                isMatch: (pathname) => pathname === '/garage/reporting'
            }
        ]
    }
};
